import { Section, SectionTitle, Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D } from "@/components/Objects3D";

const spanClass = {
  wide: "md:col-span-2",
  tall: "md:row-span-2",
  square: "",
};

export const Skills = () => {
  const { c, ui } = useContent();
  return (
    <Section id="skills" num="06" chapter={ui.skills.chapter}>
      <Shape3D shape="blob" size={72} className="absolute right-[7%] bottom-24 opacity-60 hidden md:block" duration={9} />
      <SectionTitle className="max-w-3xl">
        {ui.skills.titleA} <span className="italic text-cobalt">{ui.skills.titleB}</span>
      </SectionTitle>

      <div className="mt-14 grid md:grid-cols-3 auto-rows-fr gap-6">
        {c.skillGroups.map((group, i) => (
          <Reveal key={group.title} delay={0.05 * i} className={spanClass[group.span]}>
            <div
              className={`group h-full rounded-2xl border p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 ${
                i % 3 === 1
                  ? "bg-powder/50 border-powder"
                  : "bg-cream border-line shadow-[0_18px_40px_-26px_rgba(51,38,25,0.3)]"
              }`}
              data-testid={`skill-group-${i}`}
            >
              <p className="text-[10px] tracking-[0.28em] uppercase font-bold text-cobalt">
                {String(i + 1).padStart(2, "0")}
              </p>
              <h3 className="mt-3 font-serif text-2xl tracking-tight group-hover:text-cobalt transition-colors duration-400">
                {group.title}
              </h3>
              <ul className="mt-6">
                {group.items.map((item) => (
                  <li
                    key={item}
                    className="word-pop flex items-center gap-3 py-2.5 border-t border-choco/10 first:border-t-0 text-sm text-cocoa"
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-cobalt shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
};
